import { Trait } from '../../trait.type';
import { TraitRegistry, TraitType } from '../../trait-registry';
import { DieFace } from '../../face.type';
import { SoundType } from '../../../components/audio.svelte';
import { addModifier, dealDamage, type Player } from '../../player.type';
import { StatusEffect } from '../../status-effects.type';
import { ModifierTags } from '../../modifier.type';
import type { Die } from '../../die.type';

export class WielderTrait extends Trait {
  static baseType = TraitType.Wielder;
  static baseTitle = 'Master of Elements';
  static baseText = 'Gain access to elemental combination techniques.';
  static baseIcon = 'trait';

  type = WielderTrait.baseType;
  title = WielderTrait.baseTitle;
  text = WielderTrait.baseText;
  icon = WielderTrait.baseIcon;

  getTechniques(techniques: any[]): any[] {
    return [
      {
        ingredients: [DieFace.Fire, DieFace.Ice],
        title: 'Steam Cleaning',
        text: 'Removes 2 block and 2 ward. Apply 1 Vulnerable.',
        tags: ['damage', 'debuff'],
        audio: SoundType.AttackFire,
        activate: (target: Player, source: Player, dice: Array<Die>) => {
          const block = target.statusEffects.find(
            (modifier) => modifier.type === StatusEffect.Block,
          );
          if (block) {
            block.removeStacks(2);
          }
          const ward = target.statusEffects.find((modifier) => modifier.type === StatusEffect.Ward);
          if (ward) {
            ward.removeStacks(2);
          }
          addModifier(target, StatusEffect.Vulnerable, 1);
        },
      },
      {
        ingredients: [DieFace.Fire, DieFace.Earth],
        title: 'Liquid Hot Magma',
        text: 'Apply 2 burning, Deal damage equal to burning.',
        tags: ['damage', 'debuff'],
        audio: SoundType.AttackFire,
        activate: (target: Player, source: Player, dice: Array<Die>) => {
          addModifier(target, StatusEffect.Burning, 2);
          const burning = target.statusEffects.find(
            (modifier) => modifier.type === StatusEffect.Burning,
          );
          if (burning) {
            dealDamage({ value: burning.stacks, target, source, dice });
          }
        },
      },
      {
        ingredients: [DieFace.Lightning, DieFace.Earth],
        title: 'Grounding Charge',
        text: 'Transfer a Bane from self to enemy.',
        tags: ['cleanse', 'debuff'],
        audio: SoundType.AttackLightning,
        activate: (target: Player, source: Player, dice: Array<Die>) => {
          const bane = source.statusEffects.find((modifier) =>
            modifier.tags.includes(ModifierTags.Bane),
          );
          if (bane) {
            addModifier(target, bane.type as StatusEffect, bane.stacks);
            bane.removeStacks(bane.stacks);
          }
        },
      },
      {
        ingredients: [DieFace.Lightning, DieFace.Ice],
        title: 'Violent Tempest',
        text: 'Deal 1 damage, Apply 1 Freezing, Apply 1 Spark, two times.',
        tags: [''],
        audio: SoundType.AttackLightning,
        activate: (target: Player, source: Player, dice: Array<Die>) => {
          for (let i = 0; i < 2; i++) {
            dealDamage({ value: 1, target, source, dice });
            addModifier(target, StatusEffect.Freezing, 1);
            addModifier(target, StatusEffect.Spark, 1);
          }
        },
      },
    ];
  }
}

TraitRegistry.register(WielderTrait.baseType, WielderTrait);
